/**
 * @file コンポーネント：検索カテゴリー絞り込み ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const SearchCategory = (props) => {
    // カテゴリーリストデータ生成
    const [list, setList] = useState([]);
    useEffect(() => {
        if (props.categorylist) {
            // 1件以上の場合のみ対象
            const types = props.categorylist.filter((type) => type.count > 0);
            const tempList = types.map((type) => {
                // 大分類すべてのリンクのアクティブ状態
                const flagIsActiveAll = location.pathname === type.link;
                // 大分類すべてのリンク
                const tempChildrenAll = {
                    href: type.link,
                    isActive: flagIsActiveAll,
                    text: "All " + type.name + " (" + type.count + ")",
                };
                // 中分類のリンク
                // 1件以上の場合のみ対象
                const operationNames = type.surgicalNames.filter(
                    (operationName) => operationName.count > 0
                );
                const tempChildren = operationNames.map((operationName) => {
                    // 中分類のアクティブ状態
                    const flagIsActive =
                        location.pathname === operationName.link;
                    return {
                        href: operationName.link,
                        isActive: flagIsActive,
                        text:
                            operationName.name +
                            " (" +
                            operationName.count +
                            ")",
                    };
                });
                tempChildren.unshift(tempChildrenAll);
                // 大分類のトグル状態
                const regexp = new RegExp(type.link);
                const flagIsOpen = regexp.test(location.pathname);
                return {
                    children: tempChildren,
                    isOpen: flagIsOpen,
                    text: type.name + " (" + type.count + ")",
                };
            });
            setList(tempList);
        }
    }, [props.categorylist]);

    // Presenterに渡す
    return <Presenter {...props} list={list} />;
};
